import QueryKeys from '@/utils/QueryKeys';
import { plato_api_images_path } from '@/modules/routes';
import { UseQueryOptions } from '@tanstack/react-query';
import { BaseImage, ExtraAttributes, ImageSchema } from '@/types/api/v2/ImageSchema';
import useApi from './useApi';

interface UseImageParams<K extends (keyof BaseImage)[], E extends (keyof ExtraAttributes)[]> {
  extra_attributes?: E;
  only?: K;
  params?: object;
}

type UseImagesOptions<K extends (keyof BaseImage)[], E extends (keyof ExtraAttributes)[]> =
  UseImageParams<K, E> & Omit<UseQueryOptions<ImageSchema<K[number], E[number]>[]>, 'queryFn' | 'queryKey'>;

export default function useImages<
  K extends(keyof BaseImage)[],
  E extends (keyof ExtraAttributes)[],
>({
  extra_attributes = ([] as any as E),
  only,
  params = {},
  ...queryOptions
}: UseImagesOptions<K, E>) {
  return useApi<ImageSchema<K[number], E[number]>[], BaseImage, K, ExtraAttributes, E>({
    endpoint: plato_api_images_path({ extra_attributes, only }),
    extra_attributes,
    only,
    params,
    placeholderData: [],
    queryKey: [QueryKeys.Images, extra_attributes, only],
    ...queryOptions,
  });
}
